"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsAlarmIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _DmsLogViewer = require("./DmsLogViewer");
var _HighlightOff = _interopRequireDefault(require("@mui/icons-material/HighlightOff"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _Log = require("../../constants/Log");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DmsAlarmIcon = () => /*#__PURE__*/_react.default.createElement(_DmsLogViewer.DmsLogViewer, {
  icon: /*#__PURE__*/_react.default.createElement(_HighlightOff.default, null),
  modalTitle: _reactIntlUniversal.default.get("AlarmLogs").d("Alarm Logs"),
  logLevel: _Log.LogLevel.CRITICAL
});
exports.DmsAlarmIcon = DmsAlarmIcon;